var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"container--narrow"},[_c('v-alert',{attrs:{"type":"error"}},[_vm._v(" Valitettavasti hakemaasi sivua ei löytynyt – se on mahdollisesti joko siirretty tai poistettu. ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }